var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoGrade = function SvgIcoGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5A855",
    d: "m3.574 16.961 1.433-6.169L.221 6.644l6.315-.548L8.999.28l2.464 5.817 6.315.548-4.786 4.148 1.432 6.17L9 13.687z"
  })));
};
export default SvgIcoGrade;